import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Our ushers, choir and women's fellowship all matched perfectly for our annual conference. Tribal Designz captured our Samoan heritage with grace — the whole congregation felt unified.",
    author: "Pastor Tama F.",
    role: "Senior Pastor · Samoan Assembly of God, South Auckland",
  },
  {
    quote:
      "We needed 60 polos for our family reunion in just 3 weeks — including the village pattern and family crest. They delivered on time and the quality was beautiful. Aiga was so proud.",
    author: "Sina M.",
    role: "Reunion Coordinator · Tongan Family Reunion",
  },
  {
    quote:
      "For our youth conference camp the team turned out custom polos for 120 youth and leaders. Designs honoured our Cook Islands tivaevae traditions. Will use them every year.",
    author: "Mama Tere",
    role: "Conference Lead · Cook Islands Church Camp",
  },
];

const LOGOS = [
  "EFKS",
  "PIPC",
  "AOG SAMOA",
  "TONGAN FREE WESLEYAN",
  "CICC",
  "COOK IS PCNZ",
];

export default function Trust() {
  return (
    <section
      data-testid="trust-section"
      className="relative py-20 md:py-28 bg-zinc-950"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
            Trusted by Pacific communities
          </p>
          <h2 className="mt-3 font-display uppercase text-3xl md:text-5xl tracking-tight leading-[0.95]">
            Loved by churches, choirs <br className="hidden md:block" />
            &amp; reunion organisers across <span className="text-teal-400">NZ</span>
          </h2>
        </div>

        {/* Denomination/community strip */}
        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-y-6 gap-x-4 items-center justify-items-center opacity-80">
          {LOGOS.map((l) => (
            <div
              key={l}
              data-testid={`trust-logo-${l.replace(/\W+/g, "-").toLowerCase()}`}
              className="font-display tracking-[0.2em] text-zinc-500 hover:text-gold transition-colors text-sm md:text-base text-center"
            >
              {l}
            </div>
          ))}
        </div>

        <div className="section-divider my-16" />

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.author}
              data-testid={`testimonial-${i}`}
              className="relative bg-zinc-900 border border-zinc-800 p-7 hover:border-teal-400/50 transition-colors"
            >
              <Quote size={28} className="text-gold/40 mb-3" />
              <div className="flex gap-1 mb-4 text-gold">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} size={14} fill="currentColor" />
                ))}
              </div>
              <p className="text-zinc-200 leading-relaxed text-[15px]">"{t.quote}"</p>
              <div className="mt-5 pt-5 border-t border-zinc-800">
                <div className="font-display uppercase text-white text-base">{t.author}</div>
                <div className="text-xs uppercase tracking-wider text-zinc-500 mt-1">{t.role}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
